// extracted by mini-css-extract-plugin
module.exports = {"startContractPageRoot":"startContractPageRoot--6f3fd"};